/**
 * @file getDevice.js
 * @module src/js/functions/getDevice
 * @description
 * **A function to detect device capabilities such as touch screen support and mobile device status.**
 * - Detects if the device has a touch screen.
 * - Determines if the device is considered a mobile device based on screen width.
 *
 * @version
 * <p>
 *  2025-12-02: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Transform this from a hook to a pure JS function since it does not use any React APIs. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
export default function getDevice() {
    const hasTouchScreen ="ontouchstart" in window && navigator.maxTouchPoints > 0;
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    return { hasTouchScreen, isMobile };
}